/**
 * Format price in cents to a currency string
 *
 * @param cents - Price in cents
 * @param currencyCode - ISO 4217 currency code (default: USD)
 * @returns Formatted price string (e.g., "$24.95")
 */
export function formatPrice(
  cents: number,
  currencyCode: string = 'USD'
): string {
  const dollars = cents / 100;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(dollars);
}

/**
 * Format Shopify Storefront API price
 *
 * @param amount - Price amount as string (from Storefront API)
 * @param currencyCode - ISO 4217 currency code
 * @returns Formatted price string
 */
export function formatStorefrontPrice(
  amount: string,
  currencyCode: string = 'USD'
): string {
  const value = parseFloat(amount);

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}
